import { getStockStatusIndicatorColor } from "@coworker/app/src/components/RoomSettings/Molecules/ArticleStock.helper";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import FixaStatus from "@coworker/apprestructured/src/shared/wrappers/FixaStatus/FixaStatus";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import styles from "./item-stock-status.module.css";

interface ItemStockStatusProps {
  data?: ItemStockInfo;
  loading?: boolean;
  isError?: boolean;
  isFoodArticle?: boolean;
}

export const ItemStockStatus = ({
  data,
  loading,
  isError,
  isFoodArticle = false,
}: ItemStockStatusProps) => {
  const { t } = useTranslation();
  if (isError) {
    return (
      <FixaText textStyle={"Body.S"} className={styles["error-message-text"]}>
        {t("couldNotLoadDataString")}
      </FixaText>
    );
  }

  if (loading) {
    return <FixaSkeleton width="100%" height="16px" />;
  }

  if (!data) {
    return null;
  }

  const stockStatusVariant = getStockStatusIndicatorColor(
    data?.available ?? 0,
    data?.elevated ?? null
  );

  const elevatedStatus = isFoodArticle
    ? "(-)"
    : !data?.elevated
      ? "(0)"
      : `(${data?.elevated})`;

  return (
    <FixaStatus
      className={styles["item-stock-container"] || ""}
      label={`${data?.available} ${elevatedStatus}`}
      variant={stockStatusVariant}
      small
    />
  );
};
